const resource = {
    resource_identifier_in_use: 'API identifier {{indicator}} đã được sử dụng',
    cannot_delete_management_api: 'Không thể xóa sdvico Management API.',
    cannot_modify_management_api: 'Không thể chỉnh sửa sdvico Management API.',
};
export default Object.freeze(resource);
